<template>
  <div>
    <!-- Componente o div para la previsualización y abrir/cerrar el v-dialog -->
    <div @click="toggleDialog" class="circular-preview" >
      <v-icon v-if="!selectedIcon">mdi-account-circle</v-icon>

      <v-list-item-avatar v-if="selectedIcon" style="width: 200px; height: 240px; padding: 26px; justify-content:center">
        <div class="iconImage"><img :src="selectedIcon.icono"/></div>
      </v-list-item-avatar>
      <span class="label">{{ $t('label.image.text') }}</span>
    </div>

    <!-- v-dialog para la selección de iconos -->
    <v-dialog
      :value="dialog"
      transition="dialog-bottom-transition"
      width="40vw " :fullscreen="$vuetify.breakpoint.xsOnly"
      class="custom-width"
    >
      <template v-slot:default>
        <v-card>
          <v-toolbar color="secondary" dark >
            <v-container>
              <v-row>
                <v-col class="text-center">
                  <span>{{ $t('label.icon.text') }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-toolbar>

          <v-card-text>
           
            <v-row justify="center" :align="'center'" gap:12px>
              <v-col v-for="icon in get_icons" class="v-colIcon" :key="icon.idImagen" cols="12" md="6" style="text-align: center; margin-top:2rem;">
                <div @click="selectIcon(icon)" class="icon-item"><img :src="icon.icono"/></div>
              </v-col>
            </v-row>
           
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn variant="text" @click="closeDialog">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import EventBus from "@/utils/event_bus.js";
  import { ICONS_M, ACTION_GET_ICONS, GET_ICONS, GET_STATE_LOADING_ICONS } from "@/shared/components/icons_selector/store/types/types.js";

  export default {
    name: "icons_selector",
    props: {
      idIcon: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        selectedIcon: null,
      };
    },

    async mounted() {
      await this.actionGetIcons();
      this.initializeSelectedIcon();
      EventBus.$on('clear-icon', () => {
        this.selectedIcon= null
      });
    },

    methods: {
      ...mapActions({
        actionGetIcons: `${ICONS_M}${ACTION_GET_ICONS}`,
      }),

      toggleDialog() {
        this.dialog = !this.dialog;
      },

      selectIcon(icon) {
        this.selectedIcon = icon;
        this.dialog = false;
        EventBus.$emit("icon-selected", icon.idImagen);
      },

      closeDialog() {
        this.dialog = false;
      },

      initializeSelectedIcon() {
        if (this.idIcon) {
          // Busca el icono correspondiente al idIcon y establece selectedIcon
          this.selectedIcon = this.get_icons.find((icon) => icon.idImagen === this.idIcon) || null;
        }
      },
    },

    computed: {
      ...mapGetters({
        get_icons: [`${ICONS_M}${GET_ICONS}`],
        loading: `${ICONS_M}${GET_STATE_LOADING_ICONS}`,
      }),
    },

  };
</script>

<style lang="css" scoped>

  .circular-preview {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width:102px;
  }

  img{
    width: 4rem;
    height: 4rem;
    filter: grayscale(100%) brightness(50%) contrast(150%) hue-rotate(270deg);
  }

  .icon-item{
    cursor: pointer;
    position: relative;
  }

  .icon-item :hover{
    transform: scale(1.2);
  }

  .iconImage img{
    width: 10rem;
    height: 10rem;
  }

  .iconImage {
    object-fit: cover;
    filter: grayscale(100%) brightness(50%) contrast(150%) hue-rotate(270deg);
  }

  .circular-preview v-icon {
    font-size: 48px;
    margin-bottom: 8px;
    
  }

  .circular-preview {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .circular-preview v-icon {
    font-size: 72px;
    margin-bottom: 8px;
  }

  .label {
    font-size: 20px;
    color: #555; 
    margin-top: 8px;
    text-align: center;
  }

  .circular-preview .v-icon.v-icon{
    font-size: 200px;
  }

</style>
